import * as React from "react";
import { getter } from "@progress/kendo-react-common";

const phonenoRegExp = /^[- +()]*[0-9][- +()0-9]*$/;
const eMailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const ccardRegex = new RegExp(/^[0-9-]+$/);
const cvcRegex = new RegExp(/^[0-9]+$/);

export const OPSSegmentValidator = (value) =>
  !value ? "Please select OPS Region" : "";
export const TransportationModeValidator = (value) =>
  !value ? "Please select Transportation mode" : "";
export const RegionModeValidator = (value) =>
  !value ? "Please select Region Mode" : "";
export const CountryCodeValidator = (value) =>
  !value ? "Please select Country Code" : "";
export const SCACValidator = (value) => (!value ? "Please select SCAC" : "");
export const ContactNameValidator = (value) =>
  !value ? "Please Enter Contact Name" : "";
export const ContactEmailValidator = (value) =>
  !value
    ? "Please Enter Contact Email"
    : !value.match(eMailPattern)
    ? "Please Enter valid Contact Email"
    : "";
export const ContactPhoneValidator = (value) =>
  !value
    ? "Please Enter Contact Phone"
    : !value.match(phonenoRegExp)
    ? "Please Enter a valid Contact Phone"
    : "";
export const ctsiScac = (value) => (!value ? "Please Enter CTSI SCAC" : "");
export const cmEmail1 = (value) =>
  !value
    ? "Please Enter cmEmail1"
    : !value.match(eMailPattern)
    ? "Please Enter valid cmEmail1"
    : "";
export const cmEmail2 = (value) =>
  !value
    ? "Please Enter cmEmail2"
    : !value.match(eMailPattern)
    ? "Please Enter valid cmEmail2"
    : "";
export const carrierEmail1 = (value) =>
  !value
    ? "Please Enter carrierEmail1"
    : !value.match(eMailPattern)
    ? "Please Enter valid carrierEmail1"
    : "";
export const carrierEmail2 = (value) =>
  !value
    ? "Please Enter carrierEmail2"
    : !value.match(eMailPattern)
    ? "Please Enter valid carrierEmail2"
    : "";
export const cmPhNo1 = (value) =>
  !value
    ? "Please Enter cmPhNo1"
    : !value.match(phonenoRegExp)
    ? "Please Enter valid cmPhNo1"
    : "";
export const cmPhNo2 = (value) =>
  !value
    ? "Please Enter cmPhNo2"
    : !value.match(phonenoRegExp)
    ? "Please Enter valid cmPhNo2"
    : "";
export const carrierPhNo1 = (value) =>
  !value
    ? "Please Enter carrierPhNo1"
    : !value.match(phonenoRegExp)
    ? "Please Enter valid carrierPhNo1"
    : "";
export const carrierPhNo2 = (value) =>
  !value
    ? "Please Enter carrierPhNo2"
    : !value.match(phonenoRegExp)
    ? "Please Enter valid carrierPhNo2"
    : "";



// -------------------------------------------------------------------------------------------------------------
// ---------------------------------------------- Not used code ---------------------------------------------
// -------------------------------------------------------------------------------------------------------------

export const termsValidator = (value) =>
  value ? "" : "It's required to agree with Terms and Conditions.";
export const emailValidator = (value) =>
  !value
    ? "Email field is required."
    : eMailPattern.test(value)
    ? ""
    : "Email is not valid format.";
export const nameValidator = (value) =>
  !value
    ? "Full Name is required"
    : value.length < 7
    ? "Full Name should be at least 7 characters long."
    : "";
export const userNameValidator = (value) =>
  !value
    ? "User Name is required"
    : value.length < 5
    ? "User name should be at least 3 characters long."
    : "";
export const phoneValidator = (value) =>
  !value
    ? "Phone number is required."
    : phonenoRegExp.test(value)
    ? ""
    : "Not a valid phone number.";
export const cardValidator = (value) =>
  !value
    ? "Credit card number is required. "
    : ccardRegex.test(value)
    ? ""
    : "Not a valid credit card number format.";
export const cvcValidator = (value) =>
  !value
    ? "CVC code is required,"
    : cvcRegex.test(value) || value.length !== 3
    ? ""
    : "Not a valid CVC code format.";
export const guestsValidator = (value) =>
  !value ? "Number of guests is required" : value < 5 ? "" : "Maximum 5 guests";
export const nightsValidator = (value) =>
  value ? "" : "Number of Nights is required";
export const arrivalDateValidator = (value) =>
  value ? "" : "Arriaval Date is required";
export const colorValidator = (value) => (value ? "" : "Color is required.");
export const requiredValidator = (value) =>
  value ? "" : "Error: This field is required.";
export const passwordValidator = (value) =>
  value && value.length > 8 ? "" : "Password must be at least 8 symbols.";
export const addressValidator = (value) =>
  value ? "" : "Address is required.";

const userNameGetter = getter("username");
const emailGetter = getter("email");

export const formValidator = (values) => {
  const userName = userNameGetter(values);
  const emailValue = emailGetter(values);

  if (userName && emailValue && eMailPattern.test(emailValue)) {
    return {};
  }

  return {
    VALIDATION_SUMMARY: "Please fill the following fields.",
    ["username"]: !userName ? "User Name is required." : "",
    ["email"]:
      emailValue && eMailPattern.test(emailValue)
        ? ""
        : "Email is required and should be in valid format.",
  };
};


// -------------------------------------------------------------------------------------------------------------
// ---------------------------------------------- Not used code ---------------------------------------------
// -------------------------------------------------------------------------------------------------------------